// src/utils/allowedObjectTypes.js
// central list of all Qlik Sense object types we want to allow in the selector
export default [
  'barchart',
  'boxplot',
  'combochart',
  'container',
  'distributionplot',
  'gauge',
  'histogram',
  'kpi',
  'linechart',
  'listbox',
  'piechart',
  'pivot-table',
  'scatterplot',
  'table',
  'treemap',
  'waterfallchart',
  'bulletchart',
  'button',
  'mekkochart',
  'sn-tabbed-container',
  'sn-layout-container',
  'sn-table'
];
